import styled from "styled-components"
import { svg } from "lib/styled-system/system"
import { shouldForwardProp } from "lib/styled-system/helpers.js"

const Path = styled("path").withConfig({ shouldForwardProp })`
  ${svg}
`

export default Path
